import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=87964a7e&scoped=true&"
import script from "./TopBar.vue?vue&type=script&lang=ts&"
export * from "./TopBar.vue?vue&type=script&lang=ts&"
import style0 from "./TopBar.vue?vue&type=style&index=0&id=87964a7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87964a7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87964a7e')) {
      api.createRecord('87964a7e', component.options)
    } else {
      api.reload('87964a7e', component.options)
    }
    module.hot.accept("./TopBar.vue?vue&type=template&id=87964a7e&scoped=true&", function () {
      api.rerender('87964a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/misc/TopBar.vue"
export default component.exports